import { CanActivateFn } from "@angular/router";
import { AppConfigService } from "src/app/app-config.service";
import { TesourariaComponent } from "src/app/modules/tesouraria/components/tesouraria/tesouraria.component";

export const configGuard: CanActivateFn = () => {
  TesourariaComponent.configuraAppServiveSeForMDI();
  if (AppConfigService.config && AppConfigService.config !== null)
    return true;

  return false;
}

